import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import ModuleSlider from "../components/moduleSlider";
import TableB from "../components/TableB";
import BatchSlider from "../components/batchSlider";
import DisplaySettings from "../utils/globalSetting";
import LoadingPopup from "../components/LoadingPopup";
import Footer from "../components/Footer";
import {downloadExcell} from "../utils/downloadExcell";
import getTotalBlocks from "../utils/getTotalBlocks";
import { useNavigate } from "react-router-dom";
import ShowImageSettings from "../utils/showImageSettings";
import { Helmet } from "react-helmet";
import Pagination from "../components/Pagination";

import { useDownloadModuleStatsQuery } from "../store/apis/api";
import { useFetchBatchQuery } from "../store/apis/api";
import { useFetchBatchColourmapsQuery } from "../store/apis/api";

export default function ResultsOneBatch () {
    const navigate = useNavigate();    
    const settings = useContext(DisplaySettings);
    const batchName = settings['showBatchName'];
    const [loading, setLoading] = useState(true);    

    const links = [
        { name: "Home", link: "/landing" , isActive: true},
        { name: "Upload new images", link: "/upload", isActive:false },
        { name: "View analysis", link: "/resultsHighLevel", isActive:false },
        { name: "View batch", link: "/resultsOneBatch", isActive:false },
        { name: "About", link: "/about", isActive: false},
        { name: "Help", link: "/help", isActive: false}
        // { name: "Contact us", link: "/contactUs", isActive:false },
      ];

    const [tableData, setTableData] = useState([]);
    const [tableColours, setTableColours] = useState([]);
    const [textColours, setTextColours] = useState([]);
    const [batchCar, setBatchCar] = useState([]);
    const [blockNum, setBlockNum] = useState(0);
    const [moduleCar, setModuleCar] = useState([]);
    const [srcHeatmap, setSrcHeatmap] = useState("");
    const [indexHeatmap, setIndexHeatmap] = useState(0);
    const [heatMapName, setHeatmapName] = useState("");
    const [totalBlocks, setTotalBlocks] = useState(1);

    const { data: moduleStats, isLoading, isError } = useDownloadModuleStatsQuery(batchName);

    const { data: batchData, isLoading: isBatchLoading, isError: batchError } = useFetchBatchQuery(batchName);
    const { data: colourmapsData, isLoading: isColourmapsLoading, error: colourmapsError } = useFetchBatchColourmapsQuery({ batchName, block: blockNum });
    
    useEffect(() => {
        if (window.__REACT_SNAP__) return;
        if (batchError || colourmapsError) {
        sessionStorage.removeItem('tokens');
        navigate('/');
        }
    }, [batchError, colourmapsError, navigate]);

    useEffect(() => {
        if (window.__REACT_SNAP__) return;
        if (batchData && batchData.heatmaps.length > 0) {
            let heatmaps = batchData.heatmaps;
            setTableData(batchData.batch);
            setTableColours(batchData.colours);
            setTextColours(batchData.textColour);
            setSrcHeatmap(heatmaps[0]?.image || "");
            setHeatmapName(heatmaps[0]?.name || "");
            setBatchCar(heatmaps || []);
            setLoading(false);
        }
    }, [batchData]);

    const handleDownloadModuleStats = () => {
        if (batchData && batchData.stats) {
            downloadExcell({
                newData: batchData.stats,
                fileName: `${batchName}_modules_statistics`,
            });
        } else {
            alert('Error: No module statistics available.');
        }
    };

    const updateImageSettings = (id) => {
        setIndexHeatmap(id);
        setSrcHeatmap(batchCar[id]['image']);
        setHeatmapName(batchCar[id]['name']);
    }

    useEffect(() => {
        if (window.__REACT_SNAP__) return;
        const fetchBlocks = async () => {
            const total = await getTotalBlocks(batchName);
            setTotalBlocks(total);
        };
        fetchBlocks();
    }, [batchName]);

    if (isBatchLoading || isColourmapsLoading) {
        return (
            <Container>
                <div className="container">
                <LoadingPopup />
                </div>
            </Container>
        );
    }

    return (
        <Container>
            <Helmet>
                <title>View Batch | SolarAIDD</title>
                <meta name="description" content="View defect detection results at the batch level, with aggregated insights for all modules and cells."/>
                <meta name="robots" content="noindex, nofollow" />
                <link rel="canonical" href="https://solaraidd.csir.co.za/resultsOneBatch" />
            </Helmet>

            <Navbar links={links} isScrolled={true}/>
            {!loading && (
            <div className="container">
                <div className="title">
                    <h1> Analysis of the {batchName} batch </h1>
                    <h4> View the quality of the batch. Here you will see a detailed analysis of the quality of the batch. </h4>
                </div>
                <div className="batch-info">
                    <div className="sub-title">
                        <h2>Heatmaps showing the most defective cells for the batch</h2>
                        <div className="sub-title">
                        <h4> The heatmaps show the number of modules in the batch which have a specific defect present in the corresponding cell row and column number.
                            Since each module in a batch has the same number of cell rows and columns, we can inspect the cell locations and see which row
                            and column number is most likely to contain a specific type of defect for all modules in the particular batch.
    
                        </h4>
                        </div>
                    </div>
                    <div className="image-row">
                        <ShowImageSettings.Provider value={{indexHeatmap, updateImageSettings}}>                    
                            <TableB data={tableData} title={'Analysis of ' + batchName} fileName={'Overview_of_batch_' + batchName} colours={tableColours} textColours={textColours}/>
                        </ShowImageSettings.Provider>
                        <div className="img-container">
                            <div className="sub-heading">
                                <h3> Heat map showing the defective cells locations for type:  </h3>
                                <h3> {heatMapName} </h3>
                            </div>
                            <img src={`data:image/png;base64,${srcHeatmap}`} alt="Heatmap" />
                        </div>                    
                    </div>
                    <h3> Heatmaps for each defect type </h3>
                    <BatchSlider data={batchCar} viewMore={false}/>
                </div>
                <div className="module-info">
                    <div className="sub-title">
                    <h2> Analysis of the modules from the {batchName} batch</h2>
                    </div>                
                    <ModuleSlider data={colourmapsData.colourmaps} batchName={batchName} viewMore={true}/>
                    <Pagination 
                        currentPage={blockNum +1} 
                        totalPages={totalBlocks} 
                        onPageChange={(page) => {
                            setBlockNum(page-1)
                        }}
                    />
                    <div className="sub-context">
                        <h3> Download the summary report of the module statistics for the batch for offline analysis. </h3>
                        <button onClick={handleDownloadModuleStats}> Download module statistics </button>
                    </div>
                </div>
                <Footer/>
            </div>  
            )}     
        </Container>
    );
}

const Container = styled.div`
background: white;
.container {
    position: absolute;
    top: 3rem;
    left: 0;
    width: 100vw;
    grid-template-rows: 15vh 85vh;
    color: black;
    background: white;
    .title {
        text-align: center;
        gap: 2rem;
        padding: 3rem;
        .sub-title {
            padding: 2rem;
        }
    }
    .batch-info {
        background: #d2d9dd;
        padding: 3rem;
        gap: 2rem;
        text-align: center;
        .sub-title {
            text-align: center;            
        }
        .image-row {
            display: flex;
            gap: 6rem;
            padding: 3rem;
            align-items: start;
            justify-content: center;
            .img-container {
                width = 100vw;
                color: black;
                text-align: center;  
                .sub-heading {
                    padding: 0.5rem;
                }               
                img {
                    width: 25rem;
                    height: 100%;
                    z-index: 10;
                    box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
                    border-radius: 5px;
                }
            }
        }
    }
    .module-info {
        padding: 3rem;
        align-items: center;
        .sub-title {
            text-align: center;            
        }
        .sub-context {
            text-align: center;
            flex-direction: column; 
            justify-content: space-between;
            gap: 2rem;
            button {
                padding: 1rem 1.5rem;
                background-color: #E55B41;
                border: none;
                cursor: pointer;
                color: white;
                border-radius: 0.2rem;
                font-weight: bolder;
                font-size: 1.05rem;
                align-items: center;
            } 
        }              
    }
}
`;